import { Navigate} from "react-router-dom";

const RequireOtpGuard = ({ children }: { children: JSX.Element }) => {
  const otpConfirmed = localStorage.getItem("otpConfirmed") === "true";

  if (!otpConfirmed) {
    //  localStorage.removeItem('access_token');
    return <Navigate to="/auth/otp" replace/>;

  }

  return children;
};

export default RequireOtpGuard;
